import React, { memo, useMemo } from 'react'
import { Videocam, VideocamOff } from '@mui/icons-material'

import useUserCamera from '@tabeeb/modules/presentation/hooks/useUserCamera'
import { VideoCallUser } from '@tabeeb/modules/../users/types'
import UserActionButton from '../UserActionButton'

interface MuteUserCameraButtonProps {
  user: VideoCallUser
}

const MuteUserCameraButton: React.FC<MuteUserCameraButtonProps> = ({ user }) => {
  const { isMuted, isPresenter, currentUserId, handleClick } = useUserCamera({ user, enableHotkey: true })

  const icon = useMemo(() => {
    return isMuted ? VideocamOff : Videocam
  }, [isMuted])

  return (
    <UserActionButton
      icon={icon}
      title={isMuted ? 'Unmute camera' : 'Mute camera'}
      disabled={!isPresenter && currentUserId !== user.id}
      isMuted={isMuted}
      onClick={handleClick}
    />
  )
}

export default memo(MuteUserCameraButton)
